export default __webpack_public_path__ + "static/media/Asset-Main.c3489483.png";